import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { JtFormFieldComponent } from './_form-field/jt-form-field.component';
import { JtRowComponent } from './_form-row/jt-form-row.component';
import { JtButtonComponent } from './_button/jt-button.component';
import { JtBadgeComponent } from './_badge/jt-badge.component';
import { JtAlertComponent } from './_alert/jt-alert.component';
import { JtAlignDirective } from './_directives/jt-align.directive';
import { JtSpacingDirective } from './_directives/jt-spacing.directive';
import { JtModalComponent } from './_modal/jt-modal.component';
import { JtModalBodyDirective } from './_modal/jt-modal-body.directive';
import { JtModalFooterDirective } from './_modal/jt-modal-footer.directive';
import { JtColComponent } from './_col/jt-col.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    JtFormFieldComponent,
    JtRowComponent,
    JtButtonComponent,
    JtBadgeComponent,
    JtAlertComponent,
    JtAlignDirective,
    JtSpacingDirective,
    JtModalComponent,
    JtModalBodyDirective,
    JtModalFooterDirective,
    JtColComponent,
  ],
  exports: [
    JtFormFieldComponent,
    JtRowComponent,
    JtButtonComponent,
    JtBadgeComponent,
    JtAlertComponent,
    JtAlignDirective,
    JtSpacingDirective,
    JtModalComponent,
    JtModalBodyDirective,
    JtModalFooterDirective,
    JtColComponent,
  ]
})
export class JtUiModule { }
